<div class="stats-dialog">
  <header class="stats-dialog__header">
    <div>
      <span class="stats-dialog__eyebrow">Tournament game</span>
      <h2 mat-dialog-title id="tournament-game-stats-title">Live stats</h2>
    </div>
    <button mat-icon-button type="button" aria-label="Close game stats" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content aria-labelledby="tournament-game-stats-title">
    <div *ngIf="loading" class="stats-state" role="status" aria-live="polite">
      <mat-spinner diameter="38"></mat-spinner>
      <span>Loading game stats...</span>
    </div>

    <div *ngIf="error" class="stats-alert" role="alert">
      <span>{{ error }}</span>
      <button mat-stroked-button type="button" (click)="retry()">Retry</button>
    </div>

    <ng-container *ngIf="stats as gameStats">
      <section class="scoreboard" aria-label="Authoritative game score">
        <div class="scoreboard__team"><span>{{ gameStats.away.name }}</span><strong>{{ gameStats.away.score }}</strong></div>
        <div class="scoreboard__state">
          <span *ngIf="gameStats.game.is_live" class="live-label"><span></span>Live</span>
          <span *ngIf="!gameStats.game.is_live">{{ gameStats.game.status === 'completed' ? 'Final' : gameStats.game.status }}</span>
          <small *ngIf="gameStats.game.is_live">{{ periodLabel() }} &middot; {{ clockLabel() }}</small>
        </div>
        <div class="scoreboard__team"><span>{{ gameStats.home.name }}</span><strong>{{ gameStats.home.score }}</strong></div>
      </section>

      <p *ngIf="!hasAnyStats()" class="empty-stats" role="status">No scorekeeper stats yet</p>

      <div class="team-stats-grid">
        <section class="team-stats" *ngFor="let team of [gameStats.away, gameStats.home]">
          <header>
            <h3>{{ team.name }}</h3>
            <div><span>Team fouls <strong>{{ team.team_fouls }}</strong></span><span>Technical fouls <strong>{{ team.technical_fouls }}</strong></span></div>
          </header>
          <div class="stats-table-wrap" *ngIf="team.players.length; else noPlayers">
            <table>
              <caption>{{ team.name }} player scoring and fouls</caption>
              <thead><tr><th scope="col">Player</th><th scope="col">#</th><th scope="col">PTS</th><th scope="col">FGM</th><th scope="col">3PM</th><th scope="col">FTM</th><th scope="col">PF</th><th scope="col">TF</th></tr></thead>
              <tbody>
                <tr *ngFor="let player of team.players">
                  <th scope="row">{{ playerLabel(player) }}</th>
                  <td>{{ player.jersey || '-' }}</td>
                  <td>{{ player.points }}</td>
                  <td>{{ player.field_goal_made }}</td>
                  <td>{{ player.three_pts_made }}</td>
                  <td>{{ player.free_throw_made }}</td>
                  <td>{{ player.personal_fouls }}</td>
                  <td>{{ player.technical_fouls }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noPlayers><p class="no-players">No player stats entered.</p></ng-template>
        </section>
      </div>
    </ng-container>
  </mat-dialog-content>
</div>
